export const navList = ["about", "requirements", "alumni", "faqs"];
